import { render, staticRenderFns } from "./ss-code.vue?vue&type=template&id=5defe89a"
import script from "./ss-code.vue?vue&type=script&lang=js"
export * from "./ss-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports